import { ActionType, createReducer } from 'typesafe-actions';
import { LmsCustomGroupI } from './type';
import * as actions from './customGroup.action';
import * as types from './customGroup.actionTypes';

export type CreateCustomGroupAction = ActionType<typeof actions>;

export const customGroupInitialState: LmsCustomGroupI = {
	isSuccess: false,
	isLoading: false,
	groupName: '',
	description: '',
	userIDs: [],
	userGroupIDs: [],
};

const createCustomGroupReducer = createReducer<LmsCustomGroupI, CreateCustomGroupAction>(customGroupInitialState)
	.handleAction(actions.createCustomGroup.request, (state) => ({
		...state,
		error: null,
		isLoading: true,
		isSuccess: false,
	}))
	.handleAction(actions.createCustomGroup.success, (state) => ({
		...state,
		isLoading: false,
		isSuccess: true,
	}))
	.handleAction(actions.createCustomGroup.failure, (state, action) => ({
		...state,
		error: action.payload.error,
		isLoading: false,
		isSuccess: false,
	}))
	.handleAction(actions.updateCustomGroup.request, (state) => ({
		...state,
		error: null,
		isLoading: true,
		isSuccess: false,
	}))
	.handleAction(actions.updateCustomGroup.success, (state) => ({
		...state,
		isLoading: false,
		isSuccess: true,
	}))
	.handleAction(actions.updateCustomGroup.failure, (state, action) => ({
		...state,
		error: action.payload.error,
		isLoading: false,
		isSuccess: false,
		errorData: action.payload.errorData || null,
	}))
	.handleAction(actions.fetchCustomGroupById.request, (state) => ({
		...state,
		error: null,
		isLoading: true,
		isSuccess: false,
	}))
	.handleAction(actions.fetchCustomGroupById.success, (state, action) => {
		const customGroup = action.payload.data;
		// NOTE: User data processing commented out - custom groups no longer manage individual users
		// const users = customGroup.populated?.users || [];
		const userGroups = customGroup.populated?.userGroups || [];

		return {
			...state,
			isLoading: false,
			selectedEditLmsCustomGroup: {
				groupID: customGroup.customGroupID,
				groupName: customGroup.customGroupName,
				description: customGroup.description,
				userIDs: [], // Always empty - custom groups no longer manage individual users
				// Previously: users.map((u) => u.userID),
				userGroupIDs: userGroups.map((ug) => ug.userGroupID),
			},
			// NOTE: User selection state commented out - custom groups no longer manage individual users
			// selectedEditLmsUsers: users.map((user) => ({
			// 	key: user.userID,
			// 	value: {
			// 		userID: user.userID,
			// 		userName: user.displayName,
			// 		displayName: user.displayName,
			// 		lmsRole: user.lmsRole,
			// 	},
			// })),
			selectedEditLmsUserGroups: userGroups.map((group) => ({
				key: group.userGroupID,
				value: {
					groupID: group.userGroupID,
					groupName: group.userGroupName,
					totalUsers: group.totalUsers,
				},
			})),
		};
	})
	.handleAction(actions.fetchCustomGroupById.failure, (state, action) => ({
		...state,
		error: action.payload.error,
		isLoading: false,
		isSuccess: false,
	}))
	.handleAction(actions.deleteCustomGroup.request, (state) => ({
		...state,
		error: null,
		isLoading: true,
		isSuccess: false,
	}))
	.handleAction(actions.deleteCustomGroup.success, (state) => ({
		...state,
		isLoading: false,
		isSuccess: true,
	}))
	.handleAction(actions.deleteCustomGroup.failure, (state, action) => ({
		...state,
		error: action.payload.error,
		isLoading: false,
		isSuccess: false,
	}))
	.handleAction(types.SELECTED_EDIT_LMS_CUSTOM_GROUP as any, (state, action) => ({
		...state,
		selectedEditLmsCustomGroup: action.payload.data,
	}))
	// NOTE: User selection handler commented out - custom groups no longer manage individual users
	// .handleAction(types.SELECTED_EDIT_LMS_USERS_CUSTOM_GROUP as any, (state, action) => ({
	// 	...state,
	// 	selectedEditLmsUsers: action.payload.data,
	// }))
	.handleAction(types.SELECTED_EDIT_LMS_USER_GROUPS_CUSTOM_GROUP as any, (state, action) => ({
		...state,
		selectedEditLmsUserGroups: action.payload.data,
	}))
	.handleAction(types.SET_SHOW_MODAL as any, (state, action) => ({
		...state,
		isShowModal: action.payload.value,
	}))
	.handleAction(types.SET_SUCCESS as any, (state, action) => {
		return {
			...state,
			isSuccess: action.payload.value,
		};
	});

export { createCustomGroupReducer };
